import { type AsyncBelongsTo, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { ParityStrategySubscription } from 'lumen/models';
import ParityStrategyBreakdown from 'lumen/models/parity-strategy/breakdown';

export default class ParityStrategyHotel extends ParityStrategyBreakdown {
  // @ts-expect-error: Class inheritance
  [Type] = 'parity-strategy/hotel' as const;

  @belongsTo('parity-strategy/subscription', { async: true, inverse: null })
  declare subscription: AsyncBelongsTo<ParityStrategySubscription>;

  modelName = 'parity-strategy/hotel';

  get formattedValueWithCustomValue(): string {
    if (this.hotelAndMarketService.isDemoModeActive) {
      return `${this.formattedValue} (${Math.floor(Math.random() * 100000)})`;
    }

    const brandCode = this.subscription.get('brandCode');
    if (brandCode) {
      return `${this.formattedValue} (${brandCode})`;
    }

    return this.formattedValue;
  }

  get lossScore(): number {
    return this.lossScoreShops;
  }

  // The serializer maps `value_id` to `subscription`, so `valueId` is never set on a hotel
  get mappedValueId(): string | null {
    return this.subscription?.id ?? null;
  }

  get referenceLossScore(): number {
    return this.referenceLossScoreShops;
  }
}
